import React from 'react';
import { formatUhid } from '../hip/HipRowLines';

export default function AbhaAlreadyLinkedNotice({ patientName, uhid, patientId, onOpenPatient, opening = false }) {
  return (
    <div role="alert" style={{ padding: 12, borderRadius: 8, border: '1px solid #f59e0b', background: '#fffbeb', color: '#78350f', fontSize: 14 }}>
      <p style={{ margin: 0 }}>
        {patientName
          ? `This ABHA is already linked to ${patientName}${uhid ? ` (${formatUhid(uhid)})` : ''}. Open that patient instead of registering a new one.`
          : 'This ABHA is already linked to another patient. Open that patient instead of registering a new one.'}
      </p>
      <button
        type="button"
        disabled={opening}
        className="disabled:opacity-60 disabled:cursor-not-allowed"
        onClick={() => onOpenPatient && onOpenPatient(patientId)}
        style={{ marginTop: 8, padding: '6px 12px', borderRadius: 6, border: 'none', background: '#b45309', color: '#fff', cursor: opening ? 'not-allowed' : 'pointer' }}
      >
        {opening ? 'Opening…' : 'Open patient'}
      </button>
    </div>
  );
}
